module.exports = __webpack_public_path__ + "img/SubTaskIcon.8172bfa3.svg";